var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import BlueText from './SVG/matchplat-text-blue.svg';
import WhiteText from './SVG/matchplat-text-white.svg';
import Connect from './SVG/connect.svg';
import Crono from './SVG/logo_crono.svg';
import Enrich from './SVG/enrich.svg';
import Explore from './SVG/explore.svg';
import Overview from './SVG/overview.svg';
import Finder from './SVG/finder.svg';
import LogoSmall from './SVG/logo_small.jpg';
const LogoContainer = styled.div `
  display: ${props => props.display};
  align-items: center;
  height: ${(props) => props.height + 'rem'};
  width: auto;
  margin: ${props => props.noMargin ? '0px' : props.theme.paddingsMargins.themeMenuMargin};
  & > * {
    height: 100%;
  }
`;
const logos = {
    whiteText: WhiteText,
    blueText: BlueText,
    connect: Connect,
    crono: Crono,
    enrich: Enrich,
    explore: Explore,
    overview: Overview,
    finder: Finder,
    logoSmall: LogoSmall
};
const Logo = (_a) => {
    var { height = '4', logo = 'blueText', noMargin = false, display = 'inline-flex' } = _a, props = __rest(_a, ["height", "logo", "noMargin", "display"]);
    const LogoComponent = logos[logo];
    return (_jsx(LogoContainer, Object.assign({ display: display, noMargin: noMargin, height: height }, props, { children: _jsx("img", { src: LogoComponent, alt: "logo" }) })));
};
export default Logo;
